import { SliceCaseReducers } from '@reduxjs/toolkit'
import CreateGenericSlice from '../GenericSlice'
import {
  ImagingPrescriptionType,
  LaboratoryPrescriptiuonType,
  MedicationPrescriptionType,
  PhysiotherapyPrescriptionType,
  PrescriptionViewModel,
  ReferralPrescriptionType,
  TicketServePrescriptionType,
} from '../../models/ViewModels/PrescriptionViewModel'
import { PersonInterface } from '../../Interfaces/PersonInterface'

const store = CreateGenericSlice<
  PrescriptionViewModel,
  SliceCaseReducers<PrescriptionViewModel>
>({
  name: 'Prescription',
  initialState: {},
  reducers: {
    addOrUpdatePrescription: (state, { payload }) => {
      state.date = payload.date
      state.id = payload.id
      state.image = payload.image
      state.trackingCode = payload.trackingCode
      state.shouldPush = payload.shouldPush
      state.laboratory = payload.laboratory
      state.medication = payload.medication
      state.patient = payload.patient
      state.physiotherapy = payload.physiotherapy
      state.referral = payload.referral
      state.submitPerTab = payload.submitPerTab
      state.ticketId = payload.ticketId
      state.ticketServe = payload.ticketServe
      state.isReferenceable = payload.isReferenceable
    },
    updateMedicationRow: (state, { payload }) => {
      state.medication = {
        ...state.medication,
        rows: payload,
      } as MedicationPrescriptionType
    },
    updateLaboratoryRow: (state, { payload }) => {
      state.laboratory = {
        ...state.laboratory,
        rows: payload,
      } as LaboratoryPrescriptiuonType
    },
    updatePhysiotherapyRow: (state, { payload }) => {
      state.physiotherapy = {
        ...state.physiotherapy,
        rows: payload,
      } as PhysiotherapyPrescriptionType
    },
    updateImagingRow: (state, { payload }) => {
      state.image = {
        ...state.image,
        rows: payload,
      } as ImagingPrescriptionType
    },
    updateReferralRow: (state, { payload }) => {
      state.referral = {
        ...state.referral,
        rows: payload,
      } as ReferralPrescriptionType
    },
    updateTicketServeRow: (state, { payload }) => {
      state.ticketServe = {
        ...state.ticketServe,
        rows: payload,
      } as TicketServePrescriptionType
    },
    trueDeliveredTicketServe: (state, { payload }) => {
      const index = state.ticketServe?.rows?.findIndex((n) => n.id === payload)
      const rows = [...state.ticketServe?.rows!]
      rows[index!].isDelivered = true

      state.ticketServe = {
        rows: rows,
      } as TicketServePrescriptionType
    },
    updatePatient: (state, { payload }) => {
      state.patient = {
        rows: payload,
      } as PersonInterface
    },
    updateShouldPush: (state, { payload }) => {
      state.shouldPush = payload
    },
    addFavoriteMedicationRow(state, { payload }) {
      const index = state.medication?.rows?.findIndex(
        (n) => n.id === payload.id
      )
      if (index !== undefined && index !== -1) {
        state.medication!.rows![index!].isFavorite = true
      }
    },
    deleteFavoriteMedicationRow(state, { payload }) {
      const medications = [...state.medication?.rows!].filter(
        (n) => n.code === payload
      )
      if (medications?.length !== 0) {
        medications?.forEach((b) => {
          const index = state.medication?.rows?.findIndex((n) => n.id === b.id)
          state.medication!.rows![index!].isFavorite = false
        })
      }
    },
  },
})

export const {
  addOrUpdatePrescription,
  updateMedicationRow,
  updateShouldPush,
  updateLaboratoryRow,
  updateImagingRow,
  updateTicketServeRow,
  trueDeliveredTicketServe,
  updatePhysiotherapyRow,
  updatePatient,
  updateReferralRow,
  addFavoriteMedicationRow,
  deleteFavoriteMedicationRow
} = store.actions

export default store.reducer
